<div
  tabindex="0"
  role="checkbox"
  [attr.aria-checked]="value"
  [attr.aria-labelledby]="inputId + '-content'"
  class="flex cursor-pointer items-start justify-start gap-2 min-h-11 min-w-11 font-medium focus:!outline focus:!outline-1 focus:!outline-offset-1 !outline-gray-700"
  (click)="inp.click()"
  (keydown)="onKeyDown($event, inp)"
>
  <div
    class="relative flex h-[22px] w-[22px] flex-shrink-0 cursor-pointer items-center justify-center rounded-sm border border-solid border-[#A3AAAE] bg-white"
    [ngClass]="{
      '!border-red-500': error,
      '!border-none  !bg-blue-400': value,
    }"
  >
    <input
      #inp
      type="checkbox"
      [name]="name"
      [id]="inputId"
      [disabled]="disabled"
      [checked]="checked"
      [(ngModel)]="value"
      (blur)="blur.emit()"
      (focus)="focus.emit()"
      class="pointer-events-none relative cursor-pointer opacity-0"
      tabindex="-1"
    />
    <svg
      class="fill-current pointer-events-none absolute hidden h-[22px] w-[22px] cursor-pointer text-blue-800"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      [ngClass]="{
        '!block': value,
      }"
    >
      <g clip-path="url(#clip0_57_1712)">
        <path
          d="M6.00091 10.8001L3.20091 8.00007L2.26758 8.9334L6.00091 12.6667L14.0009 4.66673L13.0676 3.7334L6.00091 10.8001Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath inputId="clip0_57_1712">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>

  <div [id]="inputId + '-content'" class="flex items-start">
    <ng-content select="[content]"></ng-content>
  </div>
</div>

@if (error) {
<p class="text-[#EB3319] text-xs leading-none mt-1">{{ error }}</p>
}
